import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';

const TitlesContext = React.createContext();

const name = 'titlesDataStore';

export const connectToTitles = makeConnectTo(TitlesContext, name);

export const useTitles = () => React.useContext(TitlesContext);

export default class TitlesDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		titles: [],
		isLoading: true,
	};

	render() {
		const titlesDataStore = this.getStore();
		return (
			<TitlesContext.Provider value={titlesDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(titlesDataStore)
					: this.props.children}
			</TitlesContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchTitles();
	}

	componentWillUnmount() {
		if (this.titlesFetch && this.titlesFetch.cancel) {
			this.titlesFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshTitles(),
	});

	refreshTitles = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchTitles();
		return this.titlesFetch.promise;
	};

	fetchTitles = () => {
		const { skus } = this.props;
		if (Array.isArray(skus) && skus.length > 0) {
			const request = api.cancelablePost(
				`/api/products/products,images`,
				skus,
			);
			request.promise.then(this.cacheApiResponse);
			this.titlesFetch = request;
		} else {
			this.setState({ isLoading: false });
		}
	};

	cacheApiResponse = apiResponse => {
		const titles = apiResponse || [];
		this.setState({ titles, isLoading: false });
	};
}
